// extracted by mini-css-extract-plugin
export var numpadContainer = "_li-1";
export var phoneButton = "_li-0";